import $ from 'jquery';
import 'parsleyjs';
import Swal from 'sweetalert2/dist/sweetalert2.esm.js'

const swalCustomClass = {
  title: 'text-danger',
  confirmButton: 'btn btn-primary',
  cancelButton: 'btn btn-danger',
};

const swalBase = Swal.mixin({
  customClass: swalCustomClass,
  buttonsStyling: false,
  animation: false,
});

$(function() {
  var form = $("#afdc_contact_form");
  form.parsley();
  form.submit(function(event) {
    event.preventDefault();

    const submitEl = document.querySelector('#afdc_contact_form button');
    submitEl.disabled = true;
    submitEl.dataset.resetText = submitEl.textContent;
    submitEl.textContent = submitEl.dataset.loadingText;

    const hostname = window.location.hostname;
    const apiHost = (hostname === 'afdc.energy.gov') ? 'developer.nlr.gov' : 'devstage.nlr.gov';

    $.ajax({
      url: `https://${apiHost}/api/contactor/v1.json?api_key=xaEAIjAlTULBFzXOckepkUU5BqHRwGwTaBMSB2BK`,
      type: 'POST',
      data: $(this).serialize(),
      dataType: 'json',
    }).done(function() {
      swalBase.fire({
        text: 'Thanks for sending your message. We\'ll be in touch.',
        didClose: function() {
          form.trigger('reset');
        },
      });
    }).fail(function(xhr, message, error) {
      if(typeof(window.Rollbar) != 'undefined') {
        window.Rollbar.error('Unexpected contact sending failure', { error: error, message: message, response: xhr.responseText  });
      }
      swalBase.fire({
        title: '<i class="fa-solid fa-triangle-exclamation fa-width-auto"></i> Error',
        text: 'Sending your message unexpectedly failed. Please try again.',
        customClass: {
          ...swalCustomClass,
          htmlContainer: 'border-top',
        },
      });
    }).always(function() {
      submitEl.disabled = false;
      submitEl.textContent = submitEl.dataset.resetText;
    });
  });
});
